export const CARD_TEMPLATE_FAQ_LINK = 'https://www.kanbanchi.com/faqwd/how-to-use-card-templates-in-kanbanchi';
export const CARD_RECURRING_FAQ_LINK = 'https://www.kanbanchi.com/faqwd/how-to-create-recurring-tasks-cards-in-kanbanchi';
